// extracted by mini-css-extract-plugin
export default {"root":"root__bdd93e8a","mb16":"mb16__bdd93e8a","terms_table":"terms_table__bdd93e8a"};